const ONE_MINUTE_IN_MS = 60000.0;

export class SoundTrack {
    constructor(guitar, soundManager) {
        this.track = []
        this.guitar = guitar;
        this.soundManager = soundManager
        this.bpm = 120;
        this.tickCounter = 0;
        this.intervalTimer = null;

    }

    setTrack(track) {
        /*
        track = [[6,0],[5,4],...] string e fret, string in range 1-6

         */
        this.track = track;

        if (this.track.length > this.tickCounter) {
            this.tickCounter = this.track.length - 1;
        }
    }

    startPlayback() {
        clearInterval(this.intervalTimer);
        this.playTick();
        this.intervalTimer = setInterval(() => {
            this.playTick();
        }, ONE_MINUTE_IN_MS / this.bpm);
    }

    setBpm(bpm) {
        this.bpm = bpm;
        this.resetTimeout();
    }


    stopPlayback(state) {
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
            this.intervalTimer = null;
        }
    }

    rewind() {
        this.tickCounter = 0;
    }


    resetTimeout() {
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
            this.startPlayback();
        }
    }

    playTick() {

        this.guitar.resetFretsPlay();

        if (this.tickCounter >= this.track.length) {
            this.tickCounter = this.track.length - 1;
        }

        let soundBuffer = [];

        // se nota singola
        if (typeof (this.track[this.tickCounter][0]) == 'number') {
            soundBuffer.push({
                'string': this.track[this.tickCounter][0] - 1, // in soundtrack.js le corde sono in base 0-5
                'fret': this.track[this.tickCounter][1]
            });
        }

        // se array
        if (Array.isArray(this.track[this.tickCounter][0]) === true) {
            for (let i = 0; i < this.track[this.tickCounter].length; i++) {
                soundBuffer.push({
                    'string': this.track[this.tickCounter][i][0] - 1, // in soundtrack.js le corde sono in base 0-5
                    'fret': this.track[this.tickCounter][i][1]
                });
            }
        }

        // souna tutto quello che c'è nel buffer
        for (let j = 0; j < soundBuffer.length; j++) {
            let tick = soundBuffer[j];
            this.guitar.setFretPlay(tick.string, tick.fret);
            let midi = this.guitar.matrix[tick.string][tick.fret].midi;
            this.soundManager.playBeat(midi);
        }

        this.tickCounter++;
        if (this.tickCounter >= this.track.length) {
            this.tickCounter = 0;
        }
    }

}



